<template>
  <h1 class="system_content_title">评价申诉</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <!-- <el-form-item>
        <el-button type="primary" @click="showAdd">新增</el-button>
       
      </el-form-item> -->

      <el-table
        :data="state.tableData"
        stripe
        v-loading="state.loading"
        style="min-height: 70vh"
        table-layout="fixed"
      >
        <el-table-column prop="appealRemark" label="类型" />
        <el-table-column label="创建时间">
          <template #default="scope">
            {{ scope.row.createTime.split("T")[0] }}
            <br />
            {{ scope.row.createTime.split("T")[1] }}
          </template></el-table-column
        >
        <el-table-column prop="appraiseAudsName" label="评价指标" />
        <el-table-column prop="appealContent" label="内容" />
        <el-table-column label="附件">
          <template #default="scope">
            <a target="_blank" download :href="BASE_URL + scope.row.appealFileUrl">{{
              getFileName(scope.row.appealFileUrl)
            }}</a>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              size="small"
              type="warning"
              @click="showEdit(scope.row)"
              style="margin-bottom: 2px; margin-right: 2px"
              >查看详情</el-button
            >
            <el-popconfirm
              title="确定要删除吗？"
              @confirm="deleteItem(scope.row.id)"
            >
              <template #reference>
                <el-button
                  size="small"
                  type="danger"
                  style="margin-bottom: 2px; margin-right: 2px"
                  >删除</el-button
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="state.pageInfo.pageIndex"
        :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="state.pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="state.pageInfo.totalRowCount"
        v-if="state.pageInfo.totalRowCount"
        class="pageinfo"
      >
      </el-pagination>
    </div>
    <el-dialog
      v-model="state.addVisible"
      title="添加企业"
      width="30%"
      :before-close="handleClose"
    >
      <el-form label-width="120px">
        <el-form-item label="申诉评价">
          <el-select
            v-model="state.appealItem"
            placeholder="请选择"
            @change="handleChange"
          >
            <el-option
              v-for="(item, index) in state.audItemList"
              :key="item.value"
              :label="item.name"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申诉内容">
          <el-input
            v-model="state.appealText"
            :rows="4"
            placeholder="请输入内容"
            type="textarea"
          />
        </el-form-item>
        <el-form-item label="申诉附件">
          <div class="file_uploaded" v-if="state.appealFile">
            <a download target='_blank' :href="BASE_URL + state.appealFile">{{
              getFileName(state.appealFile)
            }}</a>
            <!-- <el-button type="success">下载</el-button> -->
            <el-button
              type="danger"
              style="margin-left: 4px"
              @click="state.appealFile = ''"
              >删除</el-button
            >
          </div>
          <div class="file_upload" v-else>
            <el-upload
              class="item_upload"
              action="#"
              :http-request="uploadHandler"
              accept=".pdf"
            >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">点击选择文件</div>
              <template #tip>
                <div class="el-upload__tip">请上传pdf格式的文件</div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            @click="saveAppealItem"
            :disabled="!state.audID || !state.appealText || !state.appealFile"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage,ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const BASE_URL = CONSTS.BASE_URL.substring(0,CONSTS.BASE_URL.length-1);
    if (!route.query.taskID) {
      ElMessage({
        message: "没有该工作任务，将返回到列表",
        type: "error",
      });

      setTimeout(() => {
        router.push("/system/review/reviewTasksListCompanyAlt ");
      }, 3000);
    }
   
    const state = reactive({
      tableData: [],
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      audItemList: [],
      audID: null,
      audName: null,
      appealText: null,
      appealFile: null,
      companySearchInput: "",
      appealItem: null,
      editItem: null,
      taskID: parseInt(route.query.taskID),
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.auditionApi.getAppealListByTaskID({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,
        headId: state.taskID,
        // intId: parseInt(roleId)
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getTableData();

    async function getAudItems() {
      const { data } = await api.auditionApi.getAudItemList();
      if (data.isSuccessful) {
        state.audItemList = data.resultObj;
      }
    }
    getAudItems();

    const saveAppealItem = async () => {
      console.info("get task id",state.taskID)
      const { data } = await api.auditionApi.saveAppealItem({
        ...state.editItem,
        unitAppraiseComId: state.taskID,
        appraiseAudsId: state.audID,
        appraiseAudsName: state.audName,
        appealContent: state.appealText,
        appealFileUrl: state.appealFile,
      });
      if (data.isSuccessful) {
        ElMessage({
          message: "操作成功",
          type: "success",
        });
        getTableData();
        handleClose()
      } else {
        ElMessage({
          message: data.resultMsg || "[保存申诉项目]未知错误，请联系管理员",
          type: "error",
          grouping: true,
        });
      }
    };

    const handleChange = (index) => {
      // 下拉选择框
      state.audID = state.audItemList[index].id;
      state.audName = state.audItemList[index].name;
    };
    const showAdd = () => {
      state.addVisible = true;
    };
    const showEdit = (item) => {
      state.audItemList.forEach((audItem) => {
        if (audItem.id == item.appraiseAudsId) {
          state.appealItem = audItem;
        }
      });
    
      state.audID = item.appraiseAudsId;
      state.audName = item.appraiseAudsName;
      state.appealText = item.appealContent;
      state.appealFile = item.appealFileUrl;
      state.editItem = item;
      state.addVisible = true;
    };

    const uploadHandler = async (param) => {
      const file = param.file;
      console.info("file", param.file.type);
      let formData = new FormData();
      formData.append("file", file);
       const fileName=file.name.substring(0,file.name.lastIndexOf("."))
      const { data } = await api.reviewTaskApi.saveFile({
        uappcomid: state.taskID,
        seqnum: "appeal",
        formData,
        fileName,
        file,
      });
      if (data.isSuccessful) {
        const fileUrl = data.resultObj[0];
        state.appealFile = fileUrl;
        ElMessage({
          message: "上传成功",
          type: "success",
        });
      } else {
        if (data.resultMsg) {
          ElMessage({
            message: data.resultMsg,
            type: "error",
          });
        } else {
          ElMessage({
            message: "未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    };
    const getFileName = (val) => {
      if (val != null) {
        if (val || val != "") {
          console.info("fileurl", val);
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    };

    const deleteItem = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.auditionApi.deleteAppealItem(id);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
      state.addSearchLoading = false;
    };
    const advanceAppeal = async () => {
  
      const { data } = await api.auditionApi.advanceAppealList(state.taskID);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };
    const handleClose = () => {
      state.taskID = null;
      state.audID = null;
      state.audName = null;
      state.appealText = null;
      state.appealFile = null;
      state.editItem = null;
      state.addVisible = false;
      state.appealItem=null
    };

    const showDetail = async (id) => {
      // const {data}=await api.reviewTaskApi.getReviewFormByID(id)
      // console.info("get review form",data)

      const path = `/system/review/reviewSubmit?unitAID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return;
    };

    return {
      state,
      getTableData,
      handleClose,
      deleteItem,
      showDetail,
      showAdd,
      handleChange,
      uploadHandler,
      getFileName,
      saveAppealItem,
      showEdit,
      advanceAppeal,
      BASE_URL
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
